module.exports = __webpack_public_path__ + "static/memory_img3@2x-02ea05c0220dac3cf7353605ae255085.png";